import api from './api';

export type ControlRoomSirenStopResponse = {
  ok: boolean;
  command_id?: string;
  had_active?: boolean;
  detail?: string;
};

export type ControlRoomSirenStartForPopupBody = {
  pool_id: number;
  pool_name?: string;
  event_type?: string;
  risk_level?: string;
  event_id?: number | string | null;
  source?: string;
  message?: string;
};

export type ControlRoomSirenStartResponse = {
  ok: boolean;
  alert_level?: string;
  detail?: string;
};

/** 위험 이벤트 팝업 오픈 직후 — 발송 전에 관제실 경광·끄기 UI */
export async function startControlRoomSirenForPopup(
  body: ControlRoomSirenStartForPopupBody
): Promise<ControlRoomSirenStartResponse> {
  return api.post<ControlRoomSirenStartResponse>(
    '/api/control-room-gateway/siren/start-for-popup',
    body
  );
}

export async function stopControlRoomSiren(): Promise<ControlRoomSirenStopResponse> {
  return api.post<ControlRoomSirenStopResponse>('/api/control-room-gateway/siren/stop');
}
